import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import router from '@/router';
import Cookies from 'js-cookie';
import util from '@/libs/util.js';
import { Message } from 'element-ui';

let isTokenRefreshing = false;
let retryQueue = [];

// 创建主 Axios 实例
const instance = axios.create({
    // baseURL: process.env.NODE_ENV === 'development' ? '/proxyAPI' : '/proxyAPI',
    transformRequest: [function (data) {
        return qs.stringify(data);
    }]
});

// 请求拦截器
instance.interceptors.request.use(
    config => {
        if (!config.url.includes('/api-30216/auth/refresh')) {
            const token = util.cookies.get('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        } else {
            const refreshToken = util.cookies.get('refreshToken');
            // 刷新 token 接口使用 GET 请求，参数放在 query 中
            //config.url += `?refreshToken=${refreshToken}`;
            config.headers['Authorization'] = `Bearer ${refreshToken}`;
            delete config.data; // 清除 body 数据（GET 不需要）
        }

        // 表单格式处理
        if (
            config.headers["Content-Type"] &&
            config.headers["Content-Type"].includes("application/x-www-form-urlencoded")
        ) {
            config.data = qs.stringify(config.data);
        }

        return config;
    },
    error => Promise.reject(error)
);

// 响应拦截器
instance.interceptors.response.use(
    response => response.data,
    async error => {
        const originalRequest = error.config;

        let isUnauthorized = false;
        if (error.response) {
            const status = error.response.status;
            const data = error.response.data;
            if (status === 401 ||
                (data && data.code === -999 && data.message === '用户未登录') ||
                (data && data.message === 'token已过期')) {
                isUnauthorized = true;
            }
        }

        if (isUnauthorized) {

            const retryOriginalRequest = new Promise((resolve, reject) => {
                retryQueue.push(() => {
                    // 更新 header 中的 token
                    originalRequest.headers['Authorization'] = `Bearer ${util.cookies.get('token')}`;
                    resolve(instance(originalRequest));
                });
            });

            if (!isTokenRefreshing) {
                isTokenRefreshing = true;

                try {
                    const refreshToken = util.cookies.get('refreshToken');

                    // 发起 GET 请求刷新 token，并通过 query 传递 refreshToken
                    const res = await instance.get('/api-30216/auth/refresh', {
                       // params: { refreshToken },
                        headers: { 'Content-Type': 'application/json' }
                    });

                    // 提取新 token 和 refresh_token
                    const newAccessToken = res.access_token;
                    const newRefreshToken = res.refresh_token;

                    // 更新本地存储
                    util.cookies.set('token', newAccessToken);
                    util.cookies.set('refreshToken', newRefreshToken);

                    // 执行队列中的请求
                    retryQueue.forEach(cb => cb());
                    retryQueue = [];
                } catch (err) {
                    console.error('刷新 Token 失败:', err);
                    util.cookies.remove('token');
                    util.cookies.remove('refreshToken');
                    router.push({ path: '/login' });
                } finally {
                    isTokenRefreshing = false;
                }
            }

            return retryOriginalRequest;
        } else if (error.response && error.response.data && error.response.data.code === 500) {
            Message.error(error.response.data.message || '服务内部异常');
        } else {
            Message.error({
                message: error.response.data.message,
                type: 'error'
            });
        }

        return Promise.reject(error);
    }
);

Vue.prototype.$axios = instance;